import React from 'react';

export const StartQuickly = props => (
  <svg
    width="200"
    height="100"
    viewBox="0 0 200 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M82 46L100.187 77.5H63.8135L82 46Z" fill="#757575" />
    <circle cx="94" cy="25" r="14" fill="white" />
    <rect
      x="122.771"
      y="33.7462"
      width="24.6963"
      height="24.6963"
      transform="rotate(47.8949 122.771 33.7462)"
      fill="white"
    />
  </svg>
);
